export function getDueDateFromDay(day: number | null | undefined): string {
	const today = new Date();
	const currentYear = today.getFullYear();
	const currentMonth = today.getMonth(); // 0-based
	const currentDay = today.getDate();

	// ✅ Corrigido: se o dia for inválido, usa o último dia do mês atual
	if (!day || day <= 0 || day > 31) {
		const endOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0); // último dia do mês atual
		return endOfCurrentMonth.toISOString().split("T")[0];
	}

	// Monta a data com o dia informado no mês atual
	const tentativeDate = new Date(currentYear, currentMonth, day);

	// Se o dia já passou, ajusta para o mesmo dia no mês seguinte
	if (day < currentDay) {
		const nextDate = new Date(currentYear, currentMonth + 1, day);

		// Corrige caso o mês seguinte não tenha o dia (ex: 31 de fevereiro)
		if (nextDate.getDate() !== day) {
			nextDate.setDate(0); // último dia do mês
		}
		return nextDate.toISOString().split("T")[0];
	}

	// Data ainda no mês atual
	return tentativeDate.toISOString().split("T")[0];
}


// src/shared/utils/format-date.ts
export function formatDateToBr(dateStr: string): string {
	if (!dateStr) return "-";
	const [year, month, day] = dateStr.split("-");
	return `${day}/${month}/${year}`;
}

export function generateReferenceFromPeriod(dataIni: string, dataFim: string): string {
	const [iniYear, iniMonth] = dataIni.split("-").map(Number);
	const [fimYear, fimMonth] = dataFim.split("-").map(Number);

	const formatMonth = (month: number) => month.toString().padStart(2, "0");

	if (iniYear === fimYear && iniMonth === fimMonth) {
		// Mesmo mês e ano
		return `${formatMonth(iniMonth)}/${iniYear}`;
	}

	if (iniYear === fimYear) {
		// Múltiplos meses no mesmo ano
		return `${formatMonth(iniMonth)}-${formatMonth(fimMonth)}/${iniYear}`;
	}

	// Meses e anos diferentes
	return `${formatMonth(iniMonth)}/${iniYear}-${formatMonth(fimMonth)}/${fimYear}`;
}
